import { cn } from '../../lib/cn';

/** Seventide mark: two tide lines and a low sun on deep teal. Decorative unless `title` is given. */
export function LogoMark({ className, title }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={cn('h-9 w-9 shrink-0', className)}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <rect width="64" height="64" rx="14" fill="#0f4c5c" />
      <circle cx="44" cy="20" r="6" fill="#f0b27a" />
      <path
        d="M9 33c5.5 0 7.5-5 11.5-5s6 5 11.5 5 7.5-5 11.5-5 6 5 11.5 5"
        stroke="#ffffff"
        strokeWidth="4.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M9 45c5.5 0 7.5-5 11.5-5s6 5 11.5 5 7.5-5 11.5-5 6 5 11.5 5"
        stroke="#9ad6e1"
        strokeWidth="4.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Logo({ className, compact }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark />
      <span className={cn('text-xl font-bold tracking-tight text-text', compact && 'sr-only sm:not-sr-only')}>Seventide</span>
    </span>
  );
}
